import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { RouteConstants } from './shared/constants/route.constants';
import { ShellComponent } from './shell/shell/shell.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { RoleType } from '@tfagency/core/data-access';
import { RoleGuard } from './shared/guards/role.guard';
import { unsavedChangesGuard } from './shared/guards/unsaved-changes.guard';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: RouteConstants.GROUP_CHAT_ROUTE,
    loadComponent: () => import('./group-chat/group-chat.component'),
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: RouteConstants.DASHBOARD_ROUTE,
        loadComponent: () => import('./dashboard/dashboard.component'),
      },
      {
        path: RouteConstants.STB_PROPERTIES_ROUTE,
        children: [
          {
            path: '',
            loadComponent: () => import('./stb-properties/stb-properties.component'),
          },
          {
            path: RouteConstants.ADD_ROUTE,
            loadComponent: () => import('./create-property/create-property.component'),
          },
          {
            path: RouteConstants.DUPLICATE_ROUTE,
            loadComponent: () => import('./duplicate-property/duplicate-property.component'),
          },
          {
            path: ':uid',
            loadComponent: () => import('./single-property/single-property.component'),
          },
        ],
      },

      {
        path: RouteConstants.MARKET_ANALYSIS_ROUTE,
        loadComponent: () => import('./market-analysis/market-analysis.component'),
      },

      {
        path: RouteConstants.NEWS_FEED_ROUTE,
        children: [
          {
            path: '',
            loadComponent: () => import('./news-feed/news-feed.component').then((m) => m.NewsFeedComponent),
          },

          {
            path: RouteConstants.ADD_NEWS_ROUTE,
            loadComponent: () =>
              import('./news-feed/create-edit-news-post/create-and-edit-news-post.component').then(
                (m) => m.CreateAndEditNewsPostComponent,
              ),
            canDeactivate: [unsavedChangesGuard],
          },

          {
            path: ':uid',
            loadComponent: () =>
              import('./news-feed/create-edit-news-post/create-and-edit-news-post.component').then(
                (m) => m.CreateAndEditNewsPostComponent,
              ),
            canDeactivate: [unsavedChangesGuard],
          },
        ],
      },

      {
        path: RouteConstants.ASSIGN_PROPERTIES_ROUTE,
        loadComponent: () => import('./assign-properties/assign-properties.component'),
        data: {
          roles: [RoleType.Admin, RoleType.Assistant],
        },
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: RouteConstants.BROKERS_STAFF_ROUTE,
        children: [
          {
            path: '',
            loadComponent: () => import('./brokers-staff/brokers-staff.component'),
          },
        ],
        data: {
          roles: [RoleType.Admin],
        },
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: RouteConstants.LEADS_ROUTE,
        children: [
          {
            path: '',
            loadComponent: () => import('./leads/leads.component'),
          },
          {
            // Convert reuses the create-property stepper in "convert mode" (lead carried via router state).
            // Relative back/`../` and role-scoping stay leads-scoped here.
            path: RouteConstants.CONVERT_ROUTE,
            loadComponent: () => import('./create-property/create-property.component'),
          },
        ],
        // BrokerAgent/Advisor included: GetLeadsQuery already own-scopes them server-side.
        data: {
          roles: [RoleType.Admin, RoleType.Assistant, RoleType.BrokerAgent, RoleType.Advisor],
        },
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: '**',
        redirectTo: '/dashboard',
        pathMatch: 'full',
      },
    ],
  },
];
